import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import ILearn from "../molecules/ILearn";

class PreapprovalConfidentNowGoodTimePage extends Component {
  render() {
    const content = contentMap.PreapprovalConfidentNowGoodTimePage;
    const navigationsAway =
      customNavigationMap.PreapprovalConfidentNowGoodTimePage;
    const modifiedContent = {
      ...content,
      title: null,
      subtitle: content.title,
    };

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={modifiedContent} />
            <ChoiceButtons
              content={modifiedContent}
              navigationsAway={navigationsAway}
              navigate={this.props.navigate}
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(PreapprovalConfidentNowGoodTimePage);
